<template>
  <svg class="workflow-artifact" viewBox="0 0 100 100" aria-hidden="true">
    <g v-if="kind === 'chunks'">
      <path d="M14 12h46v76H14zM22 29h26M22 50h26M22 71h26M67 22h8v55h-8M75 29h11M75 50h11M75 71h11" />
      <path class="artifact-fill" d="M82 22h10v14H82zM82 43h10v14H82zM82 64h10v14H82z" />
      <text x="22" y="23">1</text><text x="22" y="44">2</text><text x="22" y="65">3</text>
    </g>
    <g v-else-if="kind === 'pages'">
      <path d="M19 77H10V10h53v8M29 85H20V20h53v8" />
      <path d="M30 30h53v65H30zM39 42h31M39 50h22M39 62h34v23H39zM39 70h34M50 62v23" />
    </g>
    <g v-else-if="kind === 'records'">
      <path d="M10 19h80v62H10zM10 39h80M10 60h80M65 19v62" />
      <path d="M19 29h34M19 49h34M19 70h34" />
      <text x="73" y="32">03</text><text x="73" y="52">04</text><text x="73" y="73">07</text>
    </g>
    <g v-else-if="kind === 'assessment'">
      <path d="M35 14h53v72H35zM46 29h30M46 39h22M46 54h30M46 63h30M46 72h18M10 30h12v40H10M22 50h13" />
      <circle cx="8" cy="30" r="3" /><circle cx="8" cy="50" r="3" /><circle cx="8" cy="70" r="3" />
    </g>
    <g v-else>
      <path d="M5 19h90v63H5zM5 30h90M23 30v52M59 30v52M30 42h22M30 50h17M30 67h22" />
      <path class="artifact-fill" d="M9 37h10v9H9z" />
      <path d="M65 38h24v35H65zM70 46h14M70 52h14M70 58h10" />
    </g>
  </svg>
</template>
<script>
export default { name:'DocumentReviewArtifact', props:{ kind:{type:String,required:true} } };
</script>
<style scoped>
.workflow-artifact { display:block; width:100px; height:100px; flex:none; fill:none; stroke:currentColor; stroke-width:1; stroke-linejoin:round; stroke-linecap:round; }
.workflow-artifact text { fill:currentColor; stroke:none; font:8px 'Quattrocento Sans',sans-serif; }
.artifact-fill { fill:var(--review-tone); }
@container (max-width:580px) { .workflow-artifact { width:64px; height:64px; } }
</style>
